"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharedContentItem = SharedContentItem;
exports.SharedContentLiteral = SharedContentLiteral;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ContentItem = _interopRequireDefault(require("./ContentItem"));

var _ContentItemLiteral = _interopRequireDefault(require("./ContentItemLiteral"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

function _sharedKeyWrapper(WrappedComponent, SharedComponent) {
  var sharedKey = (0, _lodash.isObject)(SharedComponent) ? (0, _lodash.camelCase)(_getDisplayName(SharedComponent)) : SharedComponent;

  var SharedWrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(SharedWrapper, _React$Component);

    var _super = _createSuper(SharedWrapper);

    function SharedWrapper(props) {
      var _this;

      _classCallCheck(this, SharedWrapper);

      _this = _super.call(this, props);
      _this.sharedKey = sharedKey;
      _this.props = props;
      return _this;
    }

    _createClass(SharedWrapper, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
          sharedKey: this.sharedKey
        }, this.props));
      }
    }]);

    return SharedWrapper;
  }(_react.default.Component);

  SharedWrapper.displayName = "SharedWrapper(".concat(_getDisplayName(WrappedComponent), ")");
  return SharedWrapper;
}

function SharedContentItem(SharedComponent) {
  return _sharedKeyWrapper(_ContentItem.default, SharedComponent);
}

function SharedContentLiteral(SharedComponent) {
  return _sharedKeyWrapper(_ContentItemLiteral.default, SharedComponent);
}

var _default = {
  SharedContentItem: SharedContentItem,
  SharedContentLiteral: SharedContentLiteral
};
exports.default = _default;